import { Stack } from "@mui/material";
import type { FC } from "react";
import type {
	PortfolioListItemResponseDTO,
	PortfolioListReportingSummaryResponseDTO,
} from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { CurrencyAmount } from "web_myplann/Portfolio/Components/Redesign/ListItem/CurrencyAmount";
import { PerformanceBadge } from "web_myplann/Portfolio/Components/Redesign/ListItem/PerformanceBadge";
import { roundNumber } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	data: PortfolioListItemResponseDTO;
	summaryData: PortfolioListReportingSummaryResponseDTO[] | undefined;
};

export const PortfolioRowTrailing: FC<Props> = ({ data, summaryData }) => {
	const { t } = useResource();

	const summary = summaryData?.find((item) => item.id === data.id)?.summary;
	const value =
		summary?.totalValue === undefined
			? null
			: roundNumber(summary.totalValue, 0);
	const currencySign = summary
		? (t(Resources.PortfolioDetail.SharedLabels.Currency[summary.currency]) ??
			t(Resources.Common.CurrencySign))
		: t(Resources.Common.CurrencySign);

	return (
		<Stack alignItems="flex-end" gap={0.25}>
			<CurrencyAmount value={value} currencySign={currencySign} />
			<PerformanceBadge percent={summary?.totalEvaluationPercent ?? null} />
		</Stack>
	);
};
